module.exports = __webpack_public_path__ + "static/media/Figure10.8375c182.jpg";